import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Account } from './models/account';
import { User } from './models/user';
import { UserProfile } from './models/user-profile';
import { ContactSupportAdvisor } from './models/contact-support-advisor';

@Injectable()
export abstract class UserRepository {
  abstract getUserProfile(): Observable<UserProfile>;
  abstract getUserAccount(): Observable<Account>;
  abstract getUserContactSupportAdvisor(): Observable<ContactSupportAdvisor>;
  abstract getUserInfoById(id: number): Observable<User>;
}
